import React from "react";
import SectionShell, { CenteredHighlight } from "./SectionShell";

export default function MissionFamilySection() {
  return (
    <SectionShell
      id="csalad"
      testId="mission-family-section"
      eyebrow="Misszió"
      titleStart="A család mint a változás"
      titleAccent="tere"
      tinted
    >
      <p>
        Szerintem a gyermekek óriási lehetőséget hordoznak egy tiszta alapokon nyugvó
        társadalom létrehozásához. Nem azért, mert nekik kell kijavítaniuk mindazt,
        amit mi elrontottunk, hanem mert bennük még természetes módon jelen van az a
        nyitottság, tisztaság és kapcsolódási képesség, amelyet felnőttként sokszor
        újra kell tanulnunk. Éppen ezért hiszem, hogy a gyermekek támogatásának
        legerősebb útja a <span className="text-gold">szülők támogatása</span>.
      </p>

      {/* Symbolic image — DNA / cell-level transmission from parents to children */}
      <figure className="my-10 md:my-12">
        <div className="portrait-frame relative max-w-xl mx-auto">
          <img
            data-testid="mission-family-image"
            src="https://customer-assets.emergentagent.com/job_tiszta-tukor/artifacts/x2f1jr7s_ChatGPT%20Image%202026.%20j%C3%BAn.%2030.%2023_10_13.png"
            alt="Család együtt — a sejtszintű átkódolás és a jövő továbbadása"
            className="w-full h-auto block"
            style={{
              filter: "saturate(0.98) contrast(1.02)",
            }}
            loading="lazy"
          />
        </div>
      </figure>

      <CenteredHighlight testId="mission-children-key">
        A gyermekek a jövő kulcsai.
        <br />
        A szülők pedig azok a kapuk, amelyeken keresztül ez a jövő formálódik.
      </CenteredHighlight>

      {/* Verse-like cascade — Amikor / Akkor structure */}
      <aside
        data-testid="mission-family-cascade"
        className="my-8 md:my-10 mx-auto max-w-xl bg-warm border border-hairline px-7 md:px-10 py-8 md:py-10"
      >
        <p className="text-[11px] tracking-[0.35em] uppercase text-gold mb-4 font-body text-center">
          — Amikor
        </p>
        <p className="font-serif-display italic text-graphite text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] text-center">
          egy anya visszatalál önmagához…
          <br />
          egy apa megtalálja saját stabilitását…
          <br />
          a családban a félelem helyét fokozatosan átveszi a bizalom…
        </p>

        <p className="mt-9 text-[11px] tracking-[0.35em] uppercase text-gold mb-4 font-body text-center">
          — Akkor
        </p>
        <p className="font-serif-display italic text-graphite text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] text-center">
          nem csupán két ember élete változik meg.
          <br />
          Egy következő generáció lehetőségei is kitágulnak.
        </p>
      </aside>

      <p>
        Ezért különösen fontosnak érzem a{" "}
        <span className="text-gold">női minőség</span> helyreállítását. Az anyaság ma
        sokszor túlterhelt, magányos és elvárásokkal teli szereppé vált. Hiszem, hogy
        amikor egy nő újra kapcsolódik saját belső erejéhez, érzékenységéhez,
        intuíciójához és bölcsességéhez, akkor nem csupán ő változik meg. A család
        egész működése átalakul.
      </p>

      <p>
        Ugyanilyen fontosnak tartom a férfiak szerepét is. Nem a nőkkel szemben.
        Hanem <span className="text-gold">egymás mellett</span>. Nem versenyezve, még
        csak nem is egymást kiegészítve. Sokkal inkább két egészséges energetikai
        rendszerből <span className="text-gold">közösen teremtve</span>. Hiszem, hogy
        egy olyan férfi jelenléte, aki biztonságot, stabilitást és megtartó teret
        képes teremteni, lehetővé teszi, hogy
      </p>

      {/* Closing flow — a nő, az anya, a gyermek */}
      <aside
        data-testid="mission-family-closing"
        className="my-8 md:my-10 mx-auto max-w-xl bg-warm border border-hairline px-7 md:px-10 py-7 md:py-8"
      >
        <p className="font-serif-display italic text-graphite text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] text-center">
          A nő valóban nő lehessen.
          <br />
          A férfi valóban férfi.
          <br />
          Az anya valóban anya.
          <br />
          A gyermek pedig valóban gyermek.
          <br />
          <br />
          Mert egyiküknek sem kell olyan szerepet hordoznia,
          <br />
          amely valójában nem az övé.
        </p>
      </aside>
    </SectionShell>
  );
}
